export default __webpack_public_path__ + "static/media/introLogo.7db428ef.png";